import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled, FeatureName } from 'owa-feature-flags';

export default function(feature: FeatureName) {
    return (
        getUserConfiguration().SessionSettings.IsSubstrateSearchServiceAvailable &&
        isFeatureEnabled(feature)
    );
}
